module.exports = __webpack_public_path__ + "img/dynamic-2-l.c793c733.png";